// extracted by mini-css-extract-plugin
export default {"back_button":"Button_back_button__E1lyt","next_button":"Button_next_button__Cljql"};